'use strict';


/**
 * 模拟动画持续时间(尽量保持与animate.css设置一致)
 */
var DURATION = 300;

var animationEndEventNames = {
    'WebkitAnimation': 'webkitAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'animation': 'animationend'
};

var transitionEndEventNames = {
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'transitionend',
    OTransition: 'oTransitionEnd otransitionend',
    transition: 'transitionend'
};

module.exports = function($) {

    // 避免重复执行
    if ($.support.animation || $.support.transition) {
        return;
    }

    $.support.animation = supportEnd(animationEndEventNames);
    $.support.transition = supportEnd(transitionEndEventNames);

    if ($.support.animation) {
        $.event.special.animationend = {
            bindType: $.support.animation.end,
            delegateType: $.support.animation.end,
            handle: function(e) {
                if (e.target == this) {
                    return e.handleObj.handler.apply(this, arguments);
                }
            }
        };
    }

    if ($.support.transition) {
        $.event.special.transitionend = {
            bindType: $.support.transition.end,
            delegateType: $.support.transition.end,
            handle: function(e) {
                if (e.target == this) {
                    return e.handleObj.handler.apply(this, arguments);
                }
            }
        };
    }

    // emulate
    $.fn.emulateAnimationEnd = emulate($.support.animation, 'animationend');
    $.fn.emulateTransitionEnd = emulate($.support.transition, 'transitionend');


    function supportEnd(names) {
        var el = document.createElement('alpha');
        for (var name in names) {
            if (names.hasOwnProperty(name) && el.style[name] !== undefined) {
                return {
                    end: names[name]
                };
            }
        }
        return false; // explicit for ie8 
    }

    function emulate(support, event) {
        return function(duration) {
            var called = false;
            var $el = $(this);
            // 如果浏览器支持，调用该方法无效
            if (support) {
                return this;
            }

            if (typeof duration == 'undefined') {
                duration = support ? DURATION : 0;
            }
            if (typeof duration != 'number') {
                throw new Error('duration must be a number!');
            }
            $(this).one(event, function() {
                called = true;
            });
            var callback = function() {
                if (!called) {
                    $el.trigger(event);
                }
            };
            setTimeout(callback, duration);
            return this;
        };
    }
};